<template lang="pug">
v-container(grid-list-md)
  v-layout.menu(wrap)
    v-flex(lg12, md12, xs12)
      v-card.primary--text.subtitle-text.py-2.mb-2.justify-center.text-center(dense) REKAP TRANSAKSI DALAM WAKTU 1 BULAN
    v-layout(wrap, justify-center)
      v-flex(lg3, md3, xs12, pa-2, mb-3)
        v-card(@click="routerMenu('ENTRY')")
          v-row
            v-icon.ml-6.mr-3(large, color="success") mdi-account-edit
            v-divider(vertical)
            div
              v-card-title.subtitle-text MENUNGGU VERIFIKASI
              v-card-subtitle.caption {{ entry.length }} Transaksi
      v-flex(lg3, md3, xs12, pa-2, mb-3)
        v-card(@click="routerMenu('VERIFY')")
          v-row
            v-icon.ml-6.mr-3(large, color="success") mdi-account-check
            v-divider(vertical)
            div
              v-card-title.subtitle-text MENUNGGU APPROVAL
              v-card-subtitle.caption {{ verify.length }} Transaksi
      v-flex(lg3, md3, xs12, pa-2, mb-3)
        v-card(@click="routerMenu('SUCCESS')")
          v-row
            v-icon.ml-6.mr-3(large, color="info") mdi-checkbox-marked-outline
            v-divider(vertical)
            div
              v-card-title.subtitle-text BERHASIL
              v-card-subtitle.caption {{ success.length }} Transaksi
      v-flex(lg3, md3, xs12, pa-2, mb-3)
        v-card(@click="routerMenu('FAILED')")
          v-row
            v-icon.ml-6.mr-3(large, color="error") mdi-close-circle
            v-divider(vertical)
            div
              v-card-title.subtitle-text GAGAL
              v-card-subtitle.caption {{ failed.length }} Transaksi
      v-flex(lg3, md3, xs12, pa-2, mb-3)
        v-card(@click="routerMenu('REJECT')")
          v-row
            v-icon.ml-6.mr-3(large, color="error") mdi-delete-sweep
            v-divider(vertical)
            div
              v-card-title.subtitle-text DITOLAK
              v-card-subtitle.caption {{ reject.length }} Transaksi
      v-flex(lg3, md3, xs12, pa-2, mb-3)
        v-card(@click="routerMenu('SUSPECT')")
          v-row
            v-icon.ml-6.mr-3(large, color="warning") mdi-timer-sand
            v-divider(vertical)
            div
              v-card-title.subtitle-text DALAM PROSES
              v-card-subtitle.caption {{ suspect.length }} Transaksi
    v-flex(lg12, md12, xs12)
      v-card(v-if="lastTransaction")
        v-card-title.primary--text.subtitle-text(dense) 10 TRANSAKSI TERAKHIR USER DALAM WAKTU 1 BULAN
          v-spacer
          v-icon(color="primary") mdi-check-circle-outline
        v-divider
        v-timeline(align-top, dense)
          v-timeline-item.pr-6(
            v-for="(item, i) in lastTransaction",
            :key="i",
            :color="getColor(item.status)",
            small
          )
            v-card
              v-layout(row, pl-3, py-2)
                v-flex(lg9, md9, xs12)
                  .subtitle-text {{ item.referenceId }} - {{ item.productDescription }}
                  .caption {{ item.message }}
                  .caption(v-if="item.errorMessage") Pesan Kesalahan : {{ item.errorMessage }}
                  .caption(v-if="item.reason") Alasan Pembatalan : {{ item.reason }}
                v-flex(lg2, md2, xs12)
                  v-chip.my-1.justify-center.text-center.subsubtitle-bold(
                    small,
                    :color="getColor(item.status)",
                    style="width: 100%"
                  ) {{ item.statusName }}
</template>
<script>
export default {
  name: "FDashboardUserBengkulu",
  props: ["userDetail"],
  data() {
    return {
      listData: [],
      username: "",
      roleId: "",
    };
  },
  mounted() {
    this.doLoad();
    if (this.userDetail) {
      this.roleId = this.userDetail.user.roleId;
      this.username = this.userDetail.username;
    }
  },
  computed: {
    lastTransaction() {
      if (this.roleId == "OPR_USER") {
        return this.listData
          .filter((f) => f.userEntry == this.username)
          .slice(0, 10);
      } else if (this.roleId == "VRF_USER") {
        return this.listData
          .filter(
            (f) =>
              f.userVerify == this.username || f.userReject == this.username
          )
          .slice(0, 10);
      } else if (this.roleId == "APR_USER") {
        return this.listData
          .filter(
            (f) =>
              f.userApprove == this.username || f.userReject == this.username
          )
          .slice(0, 10);
      }
    },
    entry() {
      return this.listData.filter((f) => f.status == "ENTRY");
    },
    verify() {
      return this.listData.filter((f) => f.status == "VERIFY");
    },
    success() {
      return this.listData.filter((f) => f.status == "SUCCESS");
    },
    failed() {
      return this.listData.filter((f) => f.status == "FAILED");
    },
    reject() {
      return this.listData.filter((f) => f.status == "REJECT");
    },
    suspect() {
      return this.listData.filter((f) => f.status == "SUSPECT");
    }
  },
  methods: {
    doLoad() {
      this.$http.get("/api/system/dashboard").then((success) => {
        this.listData = success.data;
      });
    },
    getColor(status) {
      if (status == "ENTRY") {
        return "green accent-1";
      } else if (status == "VERIFY") {
        return "green accent-2";
      } else if (status == "SUSPECT") {
        return "warning";
      } else if (status == "SUCCESS") {
        return "info";
      } else if (status == "REJECT") {
        return "red lighten-3";
      } else if (status == "AUTOTRX") {
        return "success";
      } else {
        return "error";
      }
    },
    routerMenu(status) {
      if (status) {
        if (status == "ENTRY" && this.roleId == "VRF_USER") {
          this.$router
            .push({
              name: "verify-transaction",
            })
            .catch((err) => {});
        } else if (status == "VERIFY" && this.roleId == "APR_USER") {
          this.$router
            .push({
              name: "approval-transactions",
            })
            .catch((err) => {});
        } else {
          this.$router
            .push({
              name: "report-transaction",
            })
            .catch((err) => {});
        }
      }
    },
  },
};
</script>